import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled, { keyframes } from 'styled-components';

const move = keyframes`
  to {
    transform: translateX(-100%);
  }
`;

const BarContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px 0;
  background-image: linear-gradient(to right, #141e30, #243b55);
  color: white;
  font-family: 'Gelasio', sans-serif;
  font-size: 18px;
  overflow: hidden;
  white-space: nowrap;
`;

const BarContent = styled.span`
  display: block;
  width: 100%;
  transform: translateX(100%);
  animation: ${move} 30s linear infinite;
`;

const Navbar = () => {
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [isProjectDropdownOpen, setProjectDropdownOpen] = useState(false);

  const currentPage = location.pathname === '/' ? 'home' : 'other';



  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!isProjectDropdownOpen);
  };

  
  return (
    <div>
       {/* ... (existing code) ... */}

       {currentPage === 'home' && (
        <BarContainer>
          <BarContent>
            "Robotics: Where today's fiction becomes tomorrow's reality." || "In the world of robotics, knows no bounds." || "Dream big, build bigger: Robotics is the canvas for your imagination."
          </BarContent>
        </BarContainer>
      )}

      {/* ... (existing code) ... */}

      
      <nav>
        <NavLink to='/' className='nav_link'>Home</NavLink>
        <NavLink to='/task' className='nav_link'>Task</NavLink>
        <NavLink to='/members' className='nav_link'>Members</NavLink>
        <NavLink to='/message' className='nav_link'>Message</NavLink>
        <NavLink to='/survey' className='nav_link'>Survey</NavLink>

        {/* Project Dropdown */}
        <div className="dropdown">
          <span onClick={toggleProjectDropdown} className={`nav_link ${isProjectDropdownOpen ? 'with-dropdown' : ''}`}>
            Project
            {isProjectDropdownOpen && <i className="arrow up"></i>}
          </span>
          {isProjectDropdownOpen && (
            <div className="dropdown-content">
              <NavLink to='/block_diagram' className='nav_link'>Project Overview</NavLink>
              <NavLink to='/litarature_review' className='nav_link'>Literature Review</NavLink>
              <NavLink to='/equipments' className='nav_link'>Equipments</NavLink>
              <NavLink to='/paper_works' className='nav_link'>Paper Work</NavLink>
            </div>
          )}
        </div>

        <NavLink to='/software' className='nav_link'>Elements</NavLink>
        <NavLink to='/about' className='nav_link'>About</NavLink>
      </nav>

      {/* Navbar section ended */}
    </div>
  );
}


export default Navbar;


